import { z } from "zod";

export const zSpreadForm = z.object({
  has_spreads_knowledge: z.boolean(),
});

export type SpreadForm = z.infer<typeof zSpreadForm>;
